
import moment from 'moment'
import _ from 'lodash'
import { state, dispatch } from 'store'
import sheetsApi from 'api/sheets'
import {
    ArrowTurnDownLeftIcon, ArrowTurnDownRightIcon, ArrowDownIcon, ArrowUpIcon,
    SparklesIcon, HashtagIcon
} from '@heroicons/react/24/outline'
import { Link2Icon, TextIcon, CheckboxIcon, ListBulletIcon, CalendarIcon, CodeIcon, ImageIcon, RadiobuttonIcon, ReaderIcon, AvatarIcon, DrawingPinIcon, DrawingPinFilledIcon } from '@radix-ui/react-icons'
import headerIcons from './customIcons'
import { errorInValue } from './gridUtils'
export const getRunnableCells = (cells) => {
    return cells.filter((cell) => cell.isAi && cell.hasPrompt)
}

const headingActions = {
    action: [
        // {
        //     title: 'Is Primary ',
        //     icon: CursorArrowRippleIcon,
        //     checkIcon: CheckIcon,
        //     id: 'isPrimary',
        //     child:
        //     {
        //         title: 'on Duplicate primary column',
        //         icon: CursorArrowRippleIcon,
        //         id: 'onDuplicate',
        //         options: ['update', 'insert', 'ignore']
        //     },
        // },

        {
            title: 'Pin up to this column',
            icon: DrawingPinIcon,
            id: 'pin'
        },
        {
            title: 'Remove all Pinned Columns',
            icon: DrawingPinFilledIcon,
            id: 'remove-pin'
        },
        // {
        //     title: 'Delete',
        //     icon: TrashIcon,
        //     id: 'delete'
        // }
    ],

    sort: [
        // {
        //     title: 'Duplicate',
        //     icon: DocumentDuplicateIcon,
        //     id: 'duplicate'
        // },
        // {
        //     title: 'Hide',
        //     icon: EyeSlashIcon,
        //     id: 'hide'
        // },
        {
            title: 'Sort A-Z',
            icon: ArrowDownIcon,
            id: 'sort-az'
        },
        {
            title: 'Sort Z-A',
            icon: ArrowUpIcon,
            id: 'sort-za'
        }
        // {
        //     title: 'Filter',
        //     icon: UserPlusIcon,
        //     id: 'filter'
        // }
    ],
    crud: [
        // {
        //     title: 'Rename Column',
        //     icon: PencilSquareIcon,
        //     id: 'rename'
        // },
        // {
        //     title: 'Edit Column',
        //     icon: PencilSquareIcon,
        //     id: 'edit'
        // },
        // {
        //     title: 'type',
        //     icon: DocumentDuplicateIcon,
        //     id: 'type',
        //     children: true,
        //     position: 'typechange'
        // },
        {
            title: 'Insert left',
            icon: ArrowTurnDownLeftIcon,
            id: 'add-left',
            children: true,
            position: 'left'
        },
        {
            title: 'Insert right',
            icon: ArrowTurnDownRightIcon,
            id: 'add-right',
            children: true,
            position: 'right'
        }
    ]
}
const icons = {
    text: TextIcon,
    longText: TextIcon,
    string: TextIcon,
    number: HashtagIcon,
    date: CalendarIcon,
    imageurl: ImageIcon,
    url: Link2Icon,
    select: RadiobuttonIcon,
    multiSelect: ListBulletIcon,
    checkbox: CheckboxIcon,
    boolean: CheckboxIcon,
    json: CodeIcon,
    markdown: ReaderIcon,
    profile: AvatarIcon
}
const headingTypes = [
    // { title: 'AI', icon: icons.AI, id: 'Recipe' },
    { title: 'Url', icon: icons.url, id: 'url' },
    { title: 'Markdown', icon: icons.markdown, id: 'markdown' },
    { title: 'JSON', icon: icons.json, id: 'json' },
    { title: 'Text', icon: icons.text, id: 'text' },
    { title: 'Number', icon: icons.number, id: 'number' },
    { title: 'Date', icon: icons.date, id: 'date' },
    { title: 'Time', icon: icons.date, id: 'time' },
    { title: 'DateTime', icon: icons.date, id: 'datetime-local' },
    { title: 'Image', icon: icons.imageurl, id: 'imageurl' },
    { title: 'Single select', icon: icons.select, id: 'select' },
    { title: 'Multiple select', icon: icons.multiSelect, id: 'multiSelect' },
    { title: 'Boolean', icon: icons.checkbox, id: 'boolean' },
    { title: 'Formula', icon: headerIcons.FormulaGray, id: 'Formula' },
    { title: 'Profile', icon: icons.profile, id: 'profile' },
]
export const cellTypes = [
    { title: 'AI', icon: SparklesIcon, id: 'AI' },
    { title: 'Input', icon: icons.text, id: 'Input' },
    { title: 'Code', icon: headerIcons.FormulaGray, id: 'Formula' },
    { title: 'Relation', icon: Link2Icon, id: 'Relation' },
    { title: 'Lookup', icon: ReaderIcon, id: 'Lookup' }
]
export const onDuplicateOptions = [
    { title: 'Update', id: 'update' },
    { title: 'Insert', id: 'insert' },
    { title: 'Ignore', id: 'ignore' }
]
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
// const get
export const titleCase = (str) => {
    return str.replace(/(^|\s)\S/g, function (t) {
        return t.toUpperCase()
    })
}
export function getInputVariables(prompt) {
    const a = []
    prompt.replace(/{\s*([^{}]+?)\s*}/g, (_, key) => {
        const trimmedKey = key.trim()
        a.push(trimmedKey)
        return ''
    })
    return a
}
export function fillPlaceHolder(prompt, cellIdsMap, row) {
    return prompt.replace(/{\s*([^{}]+?)\s*}/g, (_, key) => {
        const label = key.trim()
        const labelId = cellIdsMap[label]
        const value = row[labelId]
        const isError = errorInValue(value)
        return isError ? null : value
    })
}
export function fillPlaceHolder2(prompt, cellIdsMap, row) {
    const ref = {}
    const p = prompt.replace(/{\s*([^{}]+?)\s*}/g, (_, key) => {
        const label = key.trim()
        const labelId = cellIdsMap[label]

        const value = row[labelId]
        const isError = errorInValue(value)
        ref[labelId] = isError ? null : value

        return `ref["${labelId}"]`
    })
    return { p, ref }
}
export function executeFormulaSingleRow(row, formula, cells) {
    const toReturn = {
        input: '',
        output: '',
        labels: []
    }
    try {
        if (!formula || !row || !cells) return toReturn
        let inputVariables = getInputVariables(formula)
        toReturn.labels = inputVariables
        const cellIdsMap = cells.reduce((acc, cell) => {
            acc[cell.label.trim().toLowerCase()] = cell._id
            return acc
        }, {})
        const referenceObject = inputVariables.reduce((acc, label) => {
            const columnId = cellIdsMap[label.trim().toLowerCase()]
            if (columnId && row[columnId]) {
                acc[label] = row[columnId]
            }
            return acc
        }, {})
        const { p, ref } = fillPlaceHolder2(formula, cellIdsMap, row)
        const fullString = `(() => {const ref = ${JSON.stringify(ref)}; const result = ${p}; return result})()`
        const output = eval(fullString)
        inputVariables = [...new Set(inputVariables)]
        if (!inputVariables) {
            return toReturn
        }
        toReturn.input = referenceObject
        toReturn.output = output
        toReturn.labels = inputVariables
        return toReturn
    } catch (e) {
        return toReturn
    }
}
export const checkReference = (row, columns, inputString, returnRefObj = false, checkValue = false) => {
    if (!inputString) return ''
    let inputVariables = getInputVariables(inputString)
    inputVariables = [...new Set(inputVariables)]
    if (!inputVariables) {
        return ''
    }
    inputVariables = inputVariables.filter((label) => !label.startsWith('ws_'))
    const labels = columns.map((cell) => cell.label.trim().toLowerCase())
    let referenceObject = inputVariables.reduce((acc, label) => {
        const columnIndex = labels.indexOf(label.trim().toLowerCase())
        if (columnIndex !== -1) {
            acc[label] = row[columnIndex]
        }
        return acc
    }, {})
    if (returnRefObj) return referenceObject
    // check every key in label is in the referenceObject and has a value and valid value
    if (checkValue) {
        const allKeys = inputVariables.filter((label) => {
            if (label.startsWith('ws_')) return false
            let val = referenceObject[label.trim().toLowerCase()]
            if (!val) return true
            if (val && typeof val === 'string') {
                val = val.toLowerCase()
                if (val === 'queued...' || val === 'inqueue...' || val === 'processing...' || val === 'adding to queue...' || val === 'warming up system...') {
                    return true
                } else if (val.includes('err_') || val.includes('errs_') || val.includes('not found')) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        })
        return allKeys
    } else {
        const allKeys = inputVariables.filter((label) => !referenceObject[label])
        return allKeys
    }
}


export function executeFormula(cell, rowId, cells) {
    try {
        if (!cell.condition) return ''
        const row = state().datagrid.filteredRows.find((r) => r._id === rowId)
        if (cell.isConditional) {
            const conditions = cell.condition
            const columnMapping = checkReference(row, cells, conditions, true)
            const result = checkCondition(conditions, columnMapping)
            if (!result) return ''
        }
        const cellIdsMap = cells.reduce((acc, cell) => {
            acc[cell.label.trim().toLowerCase()] = cell._id
            return acc
        })
        let msg = fillPlaceHolder(cell.prompt, cellIdsMap, row)
        console.log({ msg })
        const a = eval(msg)
        return a
    } catch (e) {
        console.error(e)
        return ''
    }
}
export function executeFormulaSingleRowId(rowId, formula, cells, datatype) {
    const row = state().datagrid.filteredRows.find((r) => r._id === rowId)
    return executeFormulaSingleRow(row, formula, cells, datatype)
}


export function checkCondition(condition, columnMapping) {
    if (!condition) return true
    let str = condition ? condition.toLowerCase() : ''
    Object.keys(columnMapping).forEach((key) => {
        // Escape spaces in the key for regex
        const escapedKey = key.replace(/\s+/g, '\\s+')
        const regex = new RegExp(`@${escapedKey}`, 'gi')
        str = str.replace(regex, columnMapping[key])
    })

    try {
        // Evaluate the condition safely
        return eval(str)
    } catch (e) {
        console.error('Error evaluating condition:', e)
        return false
    }
}

export function isMarkdown(input) {
    const markdownPattern = /(\n|^)#{1,6}\s|(\*\*|__)(.*?)\1|[*_-]{3,}|!\[.*?\]\(.*?\)|\[(.*?)\]\(.*?\)|^\d+\.\s|\n\s*[*-]\s/
    return markdownPattern.test(input)
}
export { headingActions, headingTypes, classNames, icons }

export const checkForRunAiCellOnRowUpdate = (row, columns) => {
    const aiCells = columns.filter((col) => col.type === 'AI' || col.type === 'Waterfall')
    if (aiCells.length === 0) return false
    const nonAiCells = columns.filter((col) => !(col.type === 'AI' || col.type === 'Waterfall'))
    if (nonAiCells.length === 0) return false
    const nonAiCellIdMap = {}
    nonAiCells.forEach((col) => {
        nonAiCellIdMap[col.label.trim().toLowerCase()] = col._id
    })
    let toRunCells = []
    aiCells.forEach((cell) => {
        const value = row[cell._id]
        if (!value) {
            const hasReferenceValue = checkReference(row, columns, cell.prompt)
            if (hasReferenceValue.length === 0) {
                toRunCells.push(cell._id)
            }
        }
    })
    return toRunCells
}
export const getInitalAndColor = (item, index) => {
    const initial = item.name.charAt(0).toUpperCase() + item.name.charAt(1)
    const colors = ['bg-red-200', 'bg-blue-200', 'bg-green-200', 'bg-yellow-200', 'bg-indigo-200', 'bg-pink-200', 'bg-purple-200']
    const color = colors[index % colors.length]
    return { initial, color }
}
export const DateFormats = [
    { title: moment().format('DD/MM/YYYY').toString(), id: 'DD/MM/YYYY' },
    { title: moment().format('DD-MM-YYYY').toString(), id: 'DD-MM-YYYY' },
    { title: moment().format('MM/DD/YYYY').toString(), id: 'MM/DD YYYY' },
    { title: moment().format('MM-DD-YYYY').toString(), id: 'MM-DD-YYYY' },
    { title: moment().format('DD MMM, YYYY').toString(), id: 'DD MMM, YYYY' }
]
export const abbreviate = (number) => {
    // like 10, 100, 1K, 10K, 100K, 1M, 10M, 100M, 1B, 10B, 100B, 1T
    if (number < 1000) return number
    const tier = (Math.log10(number) / 3) | 0
    if (tier === 0) return number
    const suffixes = ['K', 'M', 'B', 'T']
    const suffix = suffixes[tier - 1]
    const scale = Math.pow(10, tier * 3)
    const scaled = number / scale
    return scaled.toFixed(1) + suffix
}
export const abbreviateNumber = (number, suffix, prefix) => {
    const a = abbreviate(number)
    return `${prefix ?? ''} ${a} ${suffix ?? ''}`
}
export const getFormattedDate = (date, format) => {
    format = format && format.id ? format.id : format ? format : 'DD/MM/YYYY'
    if (!date) return ''
    if (!moment(date).isValid()) return ''
    if (!format) return moment(date).format('DD/MM/YYYY')
    if (moment(date).format(format) === 'Invalid date') return moment(date).format('DD/MM/YYYY')
    return moment(date).format(format)

    // return moment(date).format(format)
}

// check for tool data errors
export const checkForErrors = (data) => {
    let error = null
    data.forEach((run) => {
        const values = Object.values(run)
        if (values && _.isArray(values)) {
            values.forEach((value) => {
                if (value && typeof value === 'object' && value.error) {
                    error = value.error
                }
            })
        }
    })
    return error
}
export const getOperator = (datatype) => {
    switch (datatype) {
        case 'number':
            return [
                { title: 'Greater than', id: '>' },
                { title: 'Less than', id: '<' },
                { title: 'Equal to', id: '==' },
                { title: 'Not equal to', id: '!=' },
                { title: 'Greater than or equal to', id: '>=' },
                { title: 'Less than or equal to', id: '<=' }
            ]
        case 'date':
            return [
                { title: 'After', id: '>' },
                { title: 'Before', id: '<' },
                { title: 'On', id: '==' },
                { title: 'Not on', id: '!=' },
                { title: 'After or on', id: '>=' },
                { title: 'Before or on', id: '<=' },
                { title: 'Is Empty', id: 'empty' },
                { title: 'Is Not Empty', id: 'notempty' }
            ]
        case 'checkbox':
            return [
                { title: 'Checked', id: 'trye' },
                { title: 'Unchecked', id: 'false' }
            ]
        case 'select':
            return [
                { title: 'Equal to', id: '==' },
                { title: 'Not equal to', id: '!=' },
                { title: 'Is Empty', id: 'empty' },
                { title: 'Is Not Empty', id: 'notempty' }
            ]
        case 'multiSelect':
            return [
                { title: 'Contains', id: 'contains' },
                { title: 'Does not contain', id: 'does not contain' },
                { title: 'Is Empty', id: 'empty' },
                { title: 'Is Not Empty', id: 'notempty' }
            ]
        default:
            return [
                { title: 'Contains', id: 'contains' },
                { title: 'Does not contain', id: 'does not contain' },
                { title: 'Equal to', id: '==' },
                { title: 'Not equal to', id: '!=' },
                { title: 'Is Empty', id: 'empty' },
                { title: 'Is Not Empty', id: 'notempty' },
                { title: 'Errored', id: 'error' },
                { title: 'Not found', id: 'notfound' },
                { title: 'In Queue', id: 'inqueue' },
                { title: 'Processing', id: 'processing' }
            ]
    }
}
// one filter is an object with column, operator and value
// { column: { _id: '123', label: 'Name', datatype: 'text }, operator: {title: 'Is Empty', id : ''}, value: 'John' }
// { column: { _id: '123', label: 'Name' , datatype: 'text}, operator: {title: 'Contains', id : 'contains'}, value: 'John' }
// { column: { _id: '123', label: 'Name', datatype: 'text }, operator: {title: 'Contains', id : 'contains'}, value: 'John' }
// { column: { _id: '123', label: 'Created At', datatype: 'date }, operator: {title: 'After or on', id : '>='}, value: '13-12-2003' }
// { column: { _id: '123', label: 'Empyoees count', datatype: 'number }, operator: {title: 'Greater than', id : '>'}, value: 40 }
export const filterRows = (rows, filters, rowFilter, filteredRunningRowsIds) => {
    try {
        const validFilters = filters.filter((filter) => {
            if (filter.column && filter.operator) {
                if (filter.operator.id === 'empty' || filter.operator.id === 'notempty' || filter.operator.id === 'error' || filter.operator.id === 'notfound' || filter.operator.id === 'inqueue' || filter.operator.id === 'processing') {
                    return true
                } else {
                    return filter.value !== undefined && filter.value !== null && filter.value !== ''
                }
            } else {
                return false
            }
        })
        let filteredRows = []
        if (filteredRunningRowsIds && filteredRunningRowsIds.length > 0) {
            filteredRows = rows.filter(row => filteredRunningRowsIds.includes(row._id))
        } else {
            filteredRows = rows.filter((row) => {
                let mainOperator = 'and'
                const anyFilter = validFilters.length > 0
                if (!anyFilter) return true
                const values = validFilters.map((filter) => {
                    let include = true
                    // check column datatype then conver string value to date object if datatype is date or number if datatype is number or boolean if datatype is checkbox
                    const column = filter.column
                    const operator = filter.operator
                    if (operator && operator.id) {
                        operator.id = operator.id.toString().toLowerCase().trim()
                    }

                    let value = filter.value
                    if (value && typeof value === 'string') {
                        value = value.trim().toLowerCase()
                    }

                    const andOr = filter.condition
                    if (andOr) {
                        mainOperator = andOr.toString().toLowerCase().trim()
                    }
                    let rowValue = row[column._id]
                    if (rowValue && typeof rowValue === 'string') {
                        rowValue = rowValue.trim().toLowerCase()
                    }
                    if (operator.id === 'empty') {
                        include = include && !rowValue
                    } else if (rowValue === undefined || rowValue === null) {
                        include = false
                    }

                    if (column.datatype === 'date') {
                        rowValue = new Date(rowValue)
                        value = new Date(value)
                    }
                    if (column.datatype === 'number') {
                        rowValue = parseFloat(rowValue)
                        value = parseFloat(value)
                    }
                    if (column.datatype === 'checkbox') {
                        rowValue = rowValue === 'true'
                        value = value === 'true'
                    }
                    if (column.datatype === 'select' || column.datatype === 'multiSelect') {
                        rowValue = rowValue.toString()
                        value = value.toString().toLowerCase()
                    }
                    if (operator.id === '==') {
                        include = include && rowValue === value
                    }
                    if (operator.id === '!=') {
                        include = include && rowValue !== value
                    }
                    if (operator.id === '>') {
                        include = include && rowValue > value
                    }
                    if (operator.id === '<') {
                        include = include && rowValue < value
                    }
                    if (operator.id === '>=') {
                        include = include && rowValue >= value
                    }
                    if (operator.id === '<=') {
                        include = include && rowValue <= value
                    }
                    if (operator.id === 'contains') {
                        include = include && rowValue.toString().toLowerCase().includes(value.toString().toLowerCase())
                    }
                    if (operator.id === 'does not contain') {
                        include = include && !rowValue.toString().toLowerCase().includes(value.toString().toLowerCase())
                    }
                    if (operator.id === 'checked') {
                        include = include && rowValue
                    }
                    if (operator.id === 'unchecked') {
                        include = include && !rowValue
                    }
                    if (operator.id === '') {
                        include = include && !rowValue
                    }
                    if (operator.id === 'empty') {
                        include = include && !rowValue
                    }
                    if (operator.id === 'notempty') {
                        include = include && rowValue
                    }
                    if (operator.id === 'error') {
                        include = include && typeof rowValue === 'string' && (rowValue.toLowerCase().startsWith('error') || rowValue.toLowerCase().startsWith('err_'))
                    }
                    if (operator.id === 'notfound') {
                        include = include && typeof rowValue === 'string' && rowValue.toLowerCase().startsWith('not found')
                    }
                    if (operator.id === 'inqueue') {
                        include = include && ((typeof rowValue === 'string' && (rowValue.toLowerCase().startsWith('inqueue')) || (typeof rowValue === 'string' && rowValue.toLowerCase().startsWith('queued...')))
                            || (typeof rowValue === 'string' && rowValue.toLowerCase().startsWith('adding to queue...'))
                            || (typeof rowValue === 'string' && rowValue.toLowerCase().startsWith('warming up system...')))
                    }
                    if (operator.id === 'processing') {
                        include = include && typeof rowValue === 'string' && rowValue.toLowerCase().startsWith('processing...')
                    }
                    return include
                })
                if (mainOperator === 'and') {
                    return values.every((v) => v)
                } else {
                    return values.some((v) => v)
                }
            })
        }
        if (rowFilter.startingRow && !isNaN(rowFilter.startingRow) && rowFilter.execute) {
            const start = parseInt(rowFilter.startingRow)
            const end = parseInt(rowFilter.endingRow)
            const finalEnd = end === 0 ? filteredRows.length : start + end
            console.log('start', start, 'end', end, 'finalEnd', finalEnd)
            return filteredRows.slice(start, finalEnd)
        }
        return filteredRows
    } catch (e) {
        console.error(e)
        return rows
    }
}
export const checkRefAndPrompt = (rows, columns, column, rowIndex) => {
    return !!(column.prompt && column.prompt.length > 0)
    // const hasPrompt = !!(column.prompt && column.prompt.length > 0)
    // const hasReference = checkReference(rows[rowIndex], columns, column.prompt)
    // return { hasPrompt, hasReference: !hasReference || (hasReference && _.isArray(hasReference) && hasReference.length === 0) }

}
export const getHighlightedCells = (selection, filteredRows, headings) => {

    // const items = []
    // if (selection && selection.current && selection.current.range && selection.current.cell) {
    //     const range = selection.current.range
    //     const cell = selection.current.cell
    //     if (range && range.height === 1 && range.width === 1 && cell && cell.length === 2) {
    //         const columnIndex = cell[0]
    //         const rowIndex = cell[1]
    //         const rowId = filteredRows[rowIndex]?._id
    //         const cellId = colIds[columnIndex]
    //         const isAi = aiCellsIds.includes(cellId)
    //         if (isAi) {
    //             const hasPrompt = checkRefAndPrompt(filteredRows, headings, cols[columnIndex], rowIndex)
    //             items.push({ rowId, cellId, isAi, rowIndex, columnIndex, hasPrompt })
    //         } else {
    //             items.push({ rowId, cellId, isAi, rowIndex, columnIndex })
    //         }
    //     } else {
    //         const { x, y, height, width } = range
    //         for (let i = x; i < x + width; i++) {
    //             for (let j = y; j < y + height; j++) {
    //                 const rowId = filteredRows[j]?._id
    //                 const cellId = colIds[i]
    //                 const isAi = aiCellsIds.includes(cellId)
    //                 if (isAi) {
    //                     const hasPrompt = checkRefAndPrompt(filteredRows, headings, cols[i], j)
    //                     items.push({ rowId, cellId, isAi, rowIndex: j, columnIndex: i, hasPrompt })
    //                 } else {
    //                     items.push({ rowId, cellId, isAi: aiCellsIds.includes(cellId), rowIndex: j, columnIndex: i })
    //                 }
    //             }
    //         }
    //     }
    // }
    // return items
    return []
}
export const getSelectedRows = (selection) => {
    if (selection && selection.rows && selection.rows.items && selection.rows.items.length > 0) {
        let rows = []
        for (const item of selection.rows.items) {
            if (item && item.length === 2) {
                for (let i = item[0]; i < item[1]; i++) {
                    rows.push(i)
                }
            }
        }
        return rows
    }
    return []
}
export const checkDuplicateRows = (rows, columns, labels) => {
    if (!rows || !columns || !labels) return []
    if (rows.length === 0 || columns.length === 0 || labels.length === 0) return []
    const uniqueRows = []
    const uniqueRowIds = []
    const duplicateRowIds = []
    const finalColumns = columns.filter((col) => labels.includes(col.label))
    const columnIds = finalColumns.map((col) => col._id)
    rows.forEach((row) => {
        const rowString = columnIds
            .map((colId) => row[colId])
            .filter((val) => val !== undefined && val !== null && val !== '')
            .map((val) => val.toString().trim().toLowerCase()).join('')
        if (!uniqueRowIds.includes(rowString)) {
            uniqueRows.push(row)
            uniqueRowIds.push(rowString)
        } else {
            duplicateRowIds.push(row._id)
        }
    })
    return duplicateRowIds
}
export function humanReadableToFloat(value) {
    // Remove any non-numeric characters except decimal points, commas, or suffixes like 'k', 'M', 'B'
    value = value.replace(/[^0-9.,kmbBKM]/g, '').toLowerCase()

    // Remove commas from numbers
    value = value.replace(/,/g, '')

    let multiplier = 1

    // Check if the string ends with 'k', 'm', or 'b' and adjust the multiplier accordingly
    if (value.endsWith('k')) {
        multiplier = 1e3 // Thousand
        value = value.replace('k', '')
    } else if (value.endsWith('m')) {
        multiplier = 1e6 // Million
        value = value.replace('m', '')
    } else if (value.endsWith('b')) {
        multiplier = 1e9 // Billion
        value = value.replace('b', '')
    }

    // Convert the cleaned-up value to a float and apply the multiplier
    return parseFloat(value) * multiplier
}
export const inputArgs = ['url', 'query']
export const getSlugFromName = (name) => {
    // return pascal case
    return name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}
export const findNextCellToFocus = (cell, rowId, direction) => {
    const rows = state().datagrid.filteredRows
    const columns = state().datagrid.headings
    const rowIds = state().datagrid.filteredRows.map((r) => r._id)
    const row = rows.find((r) => r._id === rowId)
    let nextCell = null
    let rowIndex = rowIds.findIndex((r) => r === row._id)
    if (direction === 'next') {
        const currentColumnIndex = columns.findIndex((c) => c._id === cell._id)
        if (currentColumnIndex + 1 < columns.length) {
            nextCell = columns[currentColumnIndex + 1]._id
        } else {
            nextCell = columns[0]._id
            if (rowIndex + 1 < rowIds.length) {
                rowIndex = rowIndex + 1
            } else {
                nextCell = null
            }
        }
    } else if (direction === 'prev') {
        const currentColumnIndex = columns.findIndex((c) => c._id === cell)
        if (currentColumnIndex - 1 >= 0) {
            nextCell = columns[currentColumnIndex - 1]._id
        } else {
            nextCell = columns[columns.length - 1]._id
            if (rowIndex - 1 >= 0) {
                rowIndex = rowIndex - 1
            } else {
                nextCell = null
            }
        }
    }
    if (!nextCell) return null
    const rowIdNew = rowIds[rowIndex]
    return { rowId: rowIdNew, cellId: nextCell, rowIndex, rows, headings: columns }
}
export const switchSheet = async (sheet) => {
    dispatch({ type: 'SWITCH_SHEET_V2', payload: sheet?._id })
    try{
        sheetsApi.setCurrentSheet(sheet.parentTableId ?? sheet._id, sheet._id)
    
    } catch (error) {
        console.error('Failed to switch sheet:', error)
    }
}
export const getOptions = (currentLabel = '') => {
    const sheets = state().sheets
    const headings = sheets.sheets.find(s => s._id === sheets.activeSheetId)?.columns ?? [];
     
    const { workspace } = state().table
    let options = []
    let filteredCells = headings.filter((col, i) => col.label.trim().toLowerCase() !== currentLabel.trim().toLowerCase())
    filteredCells = filteredCells.filter((item) => item)
    if (filteredCells) {
        filteredCells.forEach((cell) => {
            const celllabel = cell.label
            const a = { value: celllabel, label: celllabel }
            options.push(a)
        })
    }
    if(workspace && workspace.variables) {
        workspace.variables.forEach((variable) => {
            const a = { value: `ws_${variable.key}`, label: `ws_${variable.key}`, type: 'workspace' }
            options.push(a)
        })
    }
    return options
}
export const inputs = (prompt = '', currentLabel = '') => {
    const a = []
    prompt.toLowerCase().replace(/{\s*([^{}]+?)\s*}/g, (_, key) => {
        const trimmedKey = key.trim()
        a.push(trimmedKey)
        return ''
    })
    return a
}
export const checkWriteAccess = (table) => {
    if (!table) return false
    const { session: { user }, workspace: { workspaces } } = state()
    if (!user) return false
    if (user.role === 'admin' || table?.userId === user?._id) return true
    const workspaceId = table.workspace
    if (!workspaceId) return false
    const workspace = workspaces.find(w => w._id === workspaceId)
    if (!workspace) return false
    const shared = workspace.sharedUsers.find(u => u.email === user.email)
    if (!shared) return false
    if (shared.accessType !== 'write') return false
    return true
}
export const formatError = (error) => {
    if (error && typeof error === 'string' && error.toLowerCase().startsWith('err__')) {
        const e = error.toLowerCase().split(' ')[0]
        if (e) {
            let msg = ''
            const arr = e.split('__')
            if (arr && arr.length === 3) {
                const code = arr[1]
                const serverAndtool = arr[2].replace('.', ' for tool ')
                if (code === '401') {
                    msg = `Authentication failed on MCP server ${serverAndtool} `
                } else if (code === '404') {
                    msg = `Not found on MCP server ${serverAndtool} `
                } else if (code === '500') {
                    msg = `Server error on MCP server ${serverAndtool} `
                } else if (code === '400') {
                    msg = `Bad request on MCP server ${serverAndtool} `
                } else if (code === '403') {
                    msg = `Forbidden on MCP server ${serverAndtool} `
                } else if (code === '429') {
                    msg = `Too many requests on MCP server ${serverAndtool} `
                } else {
                    msg = `${code} error on MCP server ${serverAndtool} `
                }
                return msg
            } else {
                return error
            }
        }
        return error
    }
    return error
}